import apiUrl from '../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import Paginate from 'vuejs-paginate'
import {
	BasicSelect
} from 'vue-search-select';
import VueElementLoading from 'vue-element-loading';
import DatePicker from 'vue2-datepicker'
import moment from 'moment'


export default {
	name: 'Auto-Handover-Reports',
	components: {
		BasicSelect,
		VueElementLoading,
		Paginate,
		moment,
		DatePicker
	},
	data: function() {
		return {
	  ConnectionNameList:[],
	  isLoadingConnection :false,
	  ConnectionListDataObj:{
		value: "",
		text: ""
	  },
	  connectionId :'',
	  checkedType:'ecom',
	  isLoadingSearch :false,
	  isEcom:true,
	  fromdate: '',
      todate: '',
	  BatchData:{},
	  connectionID : 0,
	  connectionName :'',
	  connErr :'',
	  pageno: 0,
	  pageCount: 0,
	  totalRows: 0,
	  limit: 10,
	  fromDate :'',
	  toDate:'',


		}
	},
	created: function() {},
	computed: {},
	filters: {
		moment: function(date) {
			if (date == null || date == '')
			  return '--'
			return moment(date).format('DD-MM-YYYY HH:mm:ss');
		}

	},
	mounted() {
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext)
		this.useremail = userdetail[0].email;
		this.currenthubid =userdetail[0].HubId[0];
		this.getConnection();
	},
	methods: {


	getConnection(){
		this.ConnectionNameList =[];
		this.isLoadingConnection =true;
		axios({
			method: "GET",
			'url': apiUrl.api_url_hubops + 'getConnectionListForComboHub?currentHubId=' + this.currenthubid ,
			headers: {
				'authorization': 'authkey xB84JJ89Hd25',
				'requestfrom': "WEB",
				'token': this.token
			}
		}).then(result => {
			this.isLoadingConnection = false;
			let response = result.data;
			if (response.ResultCode == 100) {
				for (let i = 0; i < response.ResponseData.length; i++) {
					this.ConnectionNameList.push({
						 text:  response.ResponseData[i].connectionname ,
						 value:response.ResponseData[i].connectionid,
						 
					});
				}
				
			}else{
				this.$alertify.error(response.ReturnMessage);
			}
		}, error => {
			console.error(error);
			this.isLoadingConnection =false;
		})




	},



	selectedHubConnection(selectedConnection){
		this.ConnectionListDataObj = selectedConnection;
		this.connectionId= this.ConnectionListDataObj.value;
		this.connectionID = this.ConnectionListDataObj.value; 
		this.connectionName = this.ConnectionListDataObj.text;

	},


	SearchConnection(connectionId ) {
		this.totalRows = 0;
		this.BatchData =[]
		if (this.checkedType == "cargo") {
			this.isEcom = false;
		}else{
            this.isEcom = true;
		}
		if(this.fromdate) {
			
			this.fromDate = this.fromdate?moment(this.fromdate).format('YYYY-MM-DD'):"";
		  }
		if(this.todate) {
			this.toDate= this.todate?moment(this.todate).format('YYYY-MM-DD'):"";
		  }
		
		this.isLoadingSearch =true;
		axios({
			method: "GET",
			'url': apiUrl.api_url_hubops + 'searchBatchUsingConnection?connectionId=' + connectionId + "&isEcom=" + this.isEcom + (this.fromdate?'&fromDate='+ this.fromDate:'')+ (this.todate?'&toDate='+this.toDate:'')+'&offset=' +this.pageno + '&limit='+this.limit,
			headers: {
				'authorization': 'authkey xB84JJ89Hd25',
				'requestfrom': "WEB",
				'token': this.token
			}
		}).then(result => {

			this.isLoadingSearch =false;
			let response = result.data;
			if (response.ResultCode == 100) {
				this.$alertify.success(response.ReturnMessage)
				this.BatchData = response.ResponseData;
				this.totalRows = response.totalRows;
				if (this.totalRows < this.limit) {
					this.pageCount = 1 ;
				  } else {
					this.pageCount = Math.ceil(this.totalRows / this.limit);
				  }
			}else{
				this.$alertify.error(response.ReturnMessage);
			}
		}, error => {
			console.error(error);
			this.isLoadingSearch =false;
		})
	},

	onSubmit: function() {
		this.$validator.validateAll('connArea')
		  .then((result) => {
			this.connErr = ''
			if (!result) {
			  return false;
			} else {
				if (this.connectionId == '') {
					this.connErr = 'Please select connection to proceed';
				  }
				  else{
					this.SearchConnection(this.connectionID ) ;

				  }

			  
			}
		  }).catch(() => {
			console.log('errors exist', this.errors);
		  });
	  },

	  getPaginationData(pageNum) {
		this.pageno = (pageNum - 1);
		this.SearchConnection(this.connectionID);

	  },

	checkField(){
		
		if (this.connectionId == '') {
			this.connErr = 'Please select connection to proceed';
		  }
		  else{
			this.SearchConnection(this.connectionID ) ;

		  }
		
	

	},

	reset(){
		this.connectionId = 0;
		this.ConnectionListDataObj={
			value: "",
			text: ""
		  };
		this.BatchData = [];
		this.connErr = '';

		this.checkedType='ecom',
		this.todate = '';
		this.fromdate = '';
		this.isLoadingConnection =false;
		this.limit = 10;
		this.pageno = 0 ;
		this.totalRows = 0;
	

	},

	resetflt(){
		this.todate = '';
		this.fromdate = '';
		this.SearchConnection(this.connectionID);
	},

	printBatch(data){
	    if (data.batchid == '' || data.batchid == undefined || data.batchid== null) {
			this.$alertify.error('Batch ID Not Found');
			  return false
		}
		let routeData = this.$router.resolve("/AutoHandoverBatchDetailsPrint/" +  data.batchid+ "/" + this.currenthubid + "/" + this.isEcom)
		window.open(routeData.href, '_blank');
		
	},

		


	

  
	}
}


// WEBPACK FOOTER //
// ./src/views/components/AutoHandoverReports/AutoHandoverReports.js